import {store} from '../../store/store';
import indicator, {setLoading} from './slice';

export const setIndicatorLoading = (loading: boolean) => {
    store.dispatch(setLoading(loading));
}

export default indicator